import { c as _c } from "react/compiler-runtime";
import type { InsightEvent } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type InsightEventDisplayProps = {
  insightEvent?: InsightEvent;
};
const eventItems = [{
  label: 'labels.region',
  key: 'region'
}, {
  label: 'labels.country',
  key: 'country'
}, {
  label: 'labels.postalCode',
  key: 'postalCode'
}, {
  label: 'labels.ipAddress',
  key: 'ipAddress'
}, {
  label: 'labels.userAgent',
  key: 'userAgent',
  fullWidth: true
}];
const InsightEventDisplay = t0 => {
  const $0 = _c(6);
  const {
    insightEvent
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "principalActor.insightEvent"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const renderEventItem = _temp;
  let t2;
  if ($0[1] !== insightEvent || $0[2] !== t) {
    t2 = eventItems.map(item => renderEventItem(t($ => $[item.label]), insightEvent?.[item.key as keyof InsightEvent] ?? "-", item.fullWidth));
    $0[1] = insightEvent;
    $0[2] = t;
    $0[3] = t2;
  } else {
    t2 = $0[3];
  }
  let t3;
  if ($0[4] !== t2) {
    t3 = <div className="grid grid-cols-1 gap-x-9 gap-y-4 sm:grid-cols-2">{t2}</div>;
    $0[4] = t2;
    $0[5] = t3;
  } else {
    t3 = $0[5];
  }
  return t3;
};
export default InsightEventDisplay;
function _temp(label, value, t0) {
  const fullWidth = t0 === undefined ? false : t0;
  return <div className={cx("flex flex-col gap-2 min-w-[190px]", {
    "sm:col-span-2": fullWidth
  })}><p className="text-body-2 text-tertiary">{label}</p><p className="overflow-hidden text-body-2 max-h-24 text-ellipsis line-clamp-4">{value}</p></div>;
}